export default [
  { title: 'Features', to: '#!' },
  { title: 'ChangeLog', to: '#!' },
  { title: 'Pricing', to: '#!' },
  { title: 'Docs', to: '#!' },
  { title: 'System Status', to: '#!' },
];
